// The markers on an asset's timeline.

import { api } from '../client'
import type { components } from '../schema'

export type ChapterEntry = components['schemas']['ChapterEntry']
export type SetChaptersRequest = components['schemas']['SetChaptersRequest']

/** An asset's chapters in timeline order; an empty list for one that has none. */
export function listAssetChapters(assetId: string, signal?: AbortSignal): Promise<ChapterEntry[]> {
  return api.get<ChapterEntry[]>(`/assets/${encodeURIComponent(assetId)}/chapters`, undefined, signal)
}

/** Replace an asset's chapters whole, and answer them as they now stand. */
export function setAssetChapters(assetId: string, request: SetChaptersRequest): Promise<ChapterEntry[]> {
  return api.put<ChapterEntry[]>(`/assets/${encodeURIComponent(assetId)}/chapters`, request)
}
